/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Col_VolumeInputs */

const tr_katalog_desi_page_col_volume = /** @type {(inputs: Katalog_Desi_Page_Col_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacim`)
};

const en_katalog_desi_page_col_volume = /** @type {(inputs: Katalog_Desi_Page_Col_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const de_katalog_desi_page_col_volume = /** @type {(inputs: Katalog_Desi_Page_Col_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

const ru_katalog_desi_page_col_volume = /** @type {(inputs: Katalog_Desi_Page_Col_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объём`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Katalog_Desi_Page_Col_VolumeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_col_volume = /** @type {((inputs?: Katalog_Desi_Page_Col_VolumeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Col_VolumeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_col_volume(inputs)
	if (locale === "de") return de_katalog_desi_page_col_volume(inputs)
	if (locale === "ru") return ru_katalog_desi_page_col_volume(inputs)
	return tr_katalog_desi_page_col_volume(inputs)
});